import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** PRLZ（計画的隠居旅人） */
const prlzContent: DiagnosisResultContent = {
  code: 'PRLZ',
  name: '計画的隠居旅人',
  catchphrase: '予約は済ませて、あとはひたすらのんびり。計画型の隠居ステイ',
  rarity: 4,
  style:
    '「しっかり準備して、あとは徹底的にのんびり」が信条の隠居派。宿・食事・移動は事前に押さえ、当日は時計を忘れて過ごす。観光より「滞在そのもの」を楽しみ、カフェ・温泉・宿の部屋が主舞台。効率や詰め込みとは無縁で、心と体を整える旅を計画的に実現する、現代の隠居スタイル。',
  strengths: [
    { lead: '心から休める', text: '段取り済みなので、のんびりに集中できる。' },
    { lead: 'ハズレが少ない', text: '事前に宿と食を固めるため、満足度が安定する。' },
    { lead: '同行者も楽', text: 'プレッシャーが少なく、一緒にいる人もリラックスできる。' },
  ],
  weaknesses: [
    { lead: '行動量が少ない', text: '観光スポットは最小限になりがち。' },
    { lead: '変化に弱い', text: '予定変更や急な誘いでペースが崩れると不満が出やすい。' },
    { lead: '刺激不足', text: 'のんびり一辺倒で、旅の記憶が薄くなることも。' },
  ],
  aaru: [
    { icon: 'coffee', text: 'チェックイン後はほぼ出ない' },
    { icon: 'msg', text: '「今日は宿でゆっくりね」が口癖' },
    { icon: 'coffee', text: '朝食ビュッフェに1時間以上' },
    { icon: 'camera', text: '観光より宿の設備をチェック' },
  ],
  manual: {
    good: 'のんびりペースに合わせる／宿での時間を尊重する',
    ng: '「せっかくだから回ろう」と予定を盛る',
    tips: '1日の外出は午後だけにすると心地よい',
  },
  compatibility: {
    good: 'PALZ（美食のんびり）／PRCZ（快適派）',
    conflict: 'PACE（完璧弾丸）／SALE（爆速即興）',
    tips: '「宿にいる時間」を旅程の主役にすると噛み合う',
  },
  destinations: {
    domestic: '箱根（温泉隠居）／由布院（のんびり滞在）',
    overseas: 'バリ（リゾートステイ）／南仏プロヴァンス（スロー旅）',
  },
};

export const prlzDiagnosisResult = buildDiagnosisResult(prlzContent);
